import { motion } from "framer-motion";
import { VALUES } from "../../data/site";

export const ValueProps = () => (
    <section id="about" data-testid="about-section" className="bg-bone py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
            <div className="grid lg:grid-cols-12 gap-10 mb-16 lg:mb-24">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="lg:col-span-7"
                >
                    <p className="font-mono text-[11px] tracking-[0.35em] text-gold mb-6" data-testid="about-overline">
                        01 / THE MANIFESTO
                    </p>
                    <h2 className="font-heading font-extrabold tracking-tighter text-navy text-4xl sm:text-5xl lg:text-6xl leading-[1.05]" data-testid="about-heading">
                        WHY HYDERABAD'S CORPORATES BUY FACTORY-DIRECT.
                    </h2>
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
                    className="lg:col-span-5 flex items-end"
                >
                    <p className="text-muted text-base md:text-lg leading-relaxed" data-testid="about-copy">
                        Zam Zam Furnitures designs, builds and installs every TASKLANCE® piece in our own
                        Erragadda factory — so architects, IT companies and institutions get manufacturer
                        pricing, custom dimensions and a single accountable team from blueprint to handover.
                    </p>
                </motion.div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-line" data-testid="value-props-grid">
                {VALUES.map((v, i) => (
                    <motion.div
                        key={v.num}
                        initial={{ opacity: 0, y: 32 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                        className="group border-b border-r border-line p-8 lg:p-10 bg-white hover:bg-navy transition-colors duration-500"
                        data-testid={`value-prop-${v.num}`}
                    >
                        <span className="font-mono text-xs tracking-[0.3em] text-gold">{v.num} /</span>
                        <h3 className="mt-6 font-heading font-bold tracking-tight text-xl lg:text-2xl text-navy group-hover:text-white transition-colors duration-500">
                            {v.title}
                        </h3>
                        <p className="mt-4 text-sm leading-relaxed text-muted group-hover:text-slate-300 transition-colors duration-500">
                            {v.desc}
                        </p>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);
